export default __webpack_public_path__ + "static/media/bracelet.0777306d.jpg";